<template>
  <div>
    <div class="centerx">
      <vs-popup
        class="holamundo"
        v-bind:title="'Ajuda - Cadastro de veículos da empresa'"
        :active.sync="popupActivo"
      >
        <div v-html="textoAjuda"></div>
      </vs-popup>
        <vs-popup
        class="holamundo"
        v-bind:title="'Info'"
        :active.sync="popupInfoActivo"
      >
        <div >CASO O MODELO DO SEU VEÍCULO NÃO SEJA MAIS FABRICADO E COMERCIALIZADO, COLOCAR O VALOR DE MODELO NOVO SIMILAR.</div>
      </vs-popup>
    </div>
    <div
      class="card card-header list-group-item list-group-item-action active mb-3"
    >
      <h4 class="mb-0">Cadastro de veículos da empresa</h4>
      <div
        class="badge bagde-default"
        @click="popupActivo = true"
        style="position: absolute; top: 17px; right: 15px"
      >
        Ajuda <i class="fa fa-question-circle"></i>
      </div>
    </div>
    <div class="card">
      <form style="padding: 15px" @submit="fnCadastra" method="post">
        <h4 class="mb-3">Dados dos veículos.</h4>
        <div class="form-row">
          <div class="form-group col-md-4">
            <label for="_form-periodo">Marca</label>
               <vs-select
                id="_form-periodo"
                placeholder="Selecione o período"
                class="selectExample"
                label-placeholder="Autocomplete"
                autocomplete
                v-model="cadastro.marcaId"
                style="width:100%"
                @change="listaModelos"
                >
                <vs-select-item :key="index" :value="item.marcaId"  :text="item.titulo" v-for="(item,index) in marcas" />
              </vs-select>    

              <div class="form-group mt-2" v-if="cadastro.marcaId == 0">
                <label>Outra</label>
                <input type="text" name="outramarca" v-model="outramarca" class="form-control">
              </div>              
          </div>

          <div class="form-group col-md-4">
            <label for="_form-periodo">Modelos</label>
               <vs-select
                id="_form-periodo"
                placeholder="Selecione o modelo"
                class="selectExample"
                label-placeholder="Autocomplete"
                autocomplete
                v-model="cadastro.modeloId"
                style="width:100%"
                >
                <vs-select-item :key="index" :value="item.modeloId" :text="item.titulo" v-for="(item,index) in modelos" />
              </vs-select>    

              <div class="form-group mt-2" v-if="cadastro.modeloId == 0">
                <label>Outra</label>
                <input type="text" name="outromodelo" v-model="outromodelo" class="form-control">
              </div>   

          </div>
          <div class="form-group col-md-4">
            <label for="_form-anoFabricacao">Ano Fabricação</label>
            <vue-numeric
              type="text"
              class="form-control"
              v-model="cadastro.anoFabricacao"
              id="_form-anoFabricacao"
              required
            />
          </div>
          <div class="form-group col-md-4">
            <label for="_form-anoModelo">Ano do modelo</label>
            <vue-numeric
              type="text"
              class="form-control"
              v-model="cadastro.anoModelo"
              id="_form-anoModelo"
              required
            />
          </div>
          <div class="form-group col-md-4">
            <label for="_form-valorMercado">Valor de mercado</label>
            <vue-numeric
              v-bind:precision="2"
              type="text"
              class="form-control"
              v-model="cadastro.valorMercado"
              id="_form-valorMercado"
              required
              currency="R$"
              separator="."
            />
          </div>
          <div class="form-group col-md-4">
            <label for="_form-valorNovo">Valor novo
            <div
              class=" text-primary"
              @click="popupInfoActivo = true"
              style="display:inline-flex; align-items:center; justify-content:center; padding:0; background:#007bff !important; color:#fff !important; height:18px; width:18px; border-radius:100%;"
            >
              ?
            </div>

            </label>
            <vue-numeric
              v-bind:precision="2"
              type="text"
              class="form-control"
              v-model="cadastro.valorNovo"
              id="_form-valorNovo"
              required
              currency="R$"
              separator="."
            />
          </div>
          <div class="form-group col-md-4">
            <label for="_form-valorIpva">Valor IPVA</label>
            <vue-numeric
              v-bind:precision="2"
              type="text"
              class="form-control"
              v-model="cadastro.valorIpva"
              id="_form-valorIpva"
              required
              currency="R$"
              separator="."
            />
          </div>
          <div class="form-group col-md-4">
            <label for="_form-valorSeguro">Valor Seguro</label>
            <vue-numeric
              v-bind:precision="2"
              type="text"
              class="form-control"
              v-model="cadastro.valorSeguro"
              id="_form-valorSeguro"
              required
              currency="R$"
              separator="."
            />
          </div>
          <div class="form-group col-md-4">
            <label for="_form-manutencaomensal">Valor manutenção mensal</label>
            <vue-numeric
              v-bind:precision="2"
              type="text"
              class="form-control"
              v-model="cadastro.valorManutencaoMensal"
              id="_form-manutencaomensal"
              required
              currency="R$"
              separator="."
            />
          </div>
          <div class="form-group col-md-12">
            <label for="finalidade">Finalidade</label>
            <textarea
              name="finalidade"
              v-model="cadastro.finalidade"
              maxlength="99"
              required
              id="finalidade"
              class="form-control"
              rows="2"
            ></textarea>
          </div>
        </div>
        <div style="display: flex; jusify-content: flex-end">
          <button class="btn btn-primary ml-auto">Salvar</button>
        </div>
      </form>
      <div style="padding: 15px">
        <vs-table stripe :data="content">
          <template slot="header">
            <h3>Registros</h3>
          </template>
          <template slot="thead">
            <vs-th :style="'width:' + iconArea + 'px'"> Ações </vs-th>
            <vs-th> Modelo </vs-th>
            <vs-th> Marca </vs-th>
            <vs-th> Ano modelo </vs-th>
            <vs-th> Ano fabricação </vs-th>
            <vs-th> Valor mercado </vs-th>
            <vs-th> Valor novo </vs-th>
            <vs-th> Valor IPVA </vs-th>
            <vs-th> Valor seguro </vs-th>
          </template>

          <template slot-scope="{ data }">
            <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
              <vs-td>
                <a
                  class="icone-editar"
                  data-editar
                  @click="fnEditar(indextr)"
                  title="Editar"
                >
                  <i class="i-circled i-small i-light icon-line-edit"></i>
                </a>
                <a
                  class="icone-editar"
                  data-deletar
                  @click="fnDeletar(tr.etapaId)"
                  title="Deletar"
                >
                  <i class="i-circled i-small i-light icon-trash"></i>
                </a>
              </vs-td>
              <vs-td :data="fnConcat2(tr.modeloId, tr.marcaId)">
                {{ fnConcat2(tr.modeloId, tr.marcaId) }}
              </vs-td>
              <vs-td :data="fnConcat(tr.marcaId)">
                {{ fnConcat(tr.marcaId) }}
              </vs-td>
              <vs-td :data="tr.anoModelo">
                {{ tr.anoModelo }}
              </vs-td>
              <vs-td :data="tr.anoFabricacao">
                {{ tr.anoFabricacao }}
              </vs-td>
              <vs-td :data="tr.valorMercado">
                R$ {{ formataPrice(tr.valorMercado) }}
              </vs-td>
              <vs-td :data="tr.valorNovo">
                R$ {{ formataPrice(tr.valorNovo) }}
              </vs-td>
              <vs-td :data="tr.valorIpva">
                R$ {{ formataPrice(tr.valorIpva) }}
              </vs-td>
              <vs-td :data="tr.valorSeguro">
                R$ {{ formataPrice(tr.valorSeguro) }}
              </vs-td>
              <template class="expand-user" slot="expand">
                <p class="mb-1">
                  <b> Manutenção mensal</b> R$
                  {{ formataPrice(tr.valorManutencaoMensal) }}
                </p>
                <b>Finalidade:</b>&nbsp;&nbsp;{{ tr.finalidade }}
              </template>
            </vs-tr>
          </template>
        </vs-table>
      </div>
    </div>
  </div>
</template>

<script>
import { getSuccess, formatPrice, clientKey } from "../../../global/utils";
import "vue2-datepicker/index.css";
import "vue2-datepicker/locale/pt-br";

export default {
  data() {
    return {
      content: [],
      cadastro: {},
      marcas: {},
      modelos: {},
      incluindo: false,
      iconArea: 48 * 2,
      titulo: "",
      tipo: "",
      servico: null,
      textoAjuda: null,
      popupActivo: false,
      popupInfoActivo:false,
      cadastroid: null,
      outramarca:"",
      outromodelo:""
    };
  },

  mounted() {
    this.fnGetContratacao();
    this.fnGetmarcas();
    this.fnGetPeriodos();
  },
  methods: {
    async fnGetmarcas() {
      await this.$http
        .get("listamarcas/api/")
        .then((res) => {
          this.marcas = res.data;
          this.marcas.push({marcaId:0, titulo:"Outros"});
        })
        .catch(() => {});
    },
    formatData(value) {
      return this.$moment(String(value)).format("DD/MM/YYYY");
    },
    async fnGetPeriodos() {
      await this.$http
        .get("listaperiodos/api/")
        .then((res) => {
          this.periodos = res.data;
        })
        .catch(() => {});
    },
    formataPrice(val) {
      return formatPrice(val);
    },
    async fnCadastra(e) {
      e.preventDefault();
      const metodo = this.cadastro.etapaId ? "put" : "post";
      console.log(
        this.$moment(this.cadastro.dataAquisicao, "DD/MM/AAAA").format(
          "YYYY-MM-DD"
        )
      );
      this.cadastro.dataAquisicao = this.$moment(
        this.cadastro.dataAquisicao,
        "DD/MM/AAAA"
      ).format("YYYY-MM-DD");
      this.cadastro.tsAlteracao = this.cadastro.etapaId
        ? this.$moment().format()
        : null;
      const completaUrl = this.cadastro.etapaId
        ? "/" + this.cadastro.etapaId
        : "";
            let headers = {
        'outramarca': this.outramarca,
        'outromodelo':this.outromodelo
      };        
      await this.$http[metodo]("/etapa_11" + completaUrl + "?outramarca="+this.outramarca+"&outromodelo="+this.outromodelo, this.cadastro,{headers:headers})
        .then((res) => {
          if (metodo == "post") {
            this.content.push(res.data);
          }
          getSuccess();
          this.cadastro = {
            contratacaoId: this.cadastroid,
          };
          window.location.reload(true);

        })
        .catch(() => {});
    },

    async fnGetContratacao() {
      await this.$http
        .get(`contratacao/codigo/${this.$route.params.codigoContrato}/etapa_11`)
        .then((res) => {
          this.cadastro.contratacaoId = res.data.contratacaoId;
          this.cadastroid = res.data.contratacaoId;
          if (res.data.contratacoesEVO11 != null) {
            var toString = JSON.stringify(res.data.contratacoesEVO11);
            var toJson = JSON.parse(toString);
            for (var i = 0; i < toJson.length; i++) {
              this.content.push(toJson[i]);
            }
          }
        })
        .catch(() => {});
      await this.$http
        .get(`contratacao/lista/${this.$route.params.codigoContrato}`)
        .then((res) => {
          this.servico = res.data.servicos;
          this.textoAjuda = this.servico.textoAjuda11;
        });
    },
    fnCancela() {
      this.incluindo = false;
      this.titulo = "";
      this.tipo = "";
    },
    fnEdicao(val) {
      if (val == "Incluindo") {
        this.incluindo = true;
        this.titulo = "Incluindo novo registro";
        this.tipo = "Inclusão";
      }
    },
    fnEditar(i) {
      this.cadastro = this.content[i];
      this.cadastro.dataAquisicao = this.formatData(
        this.cadastro.dataAquisicao
      );
      this.listaModelos();
    },
    fnConcat(val) {
      var item = this.marcas.filter((administracoes) => {
        return administracoes.marcaId == val;
      });
      var toString = JSON.stringify(item);
      var toJson = JSON.parse(toString);
      return toJson[0].titulo;
    },
    fnConcatModelos(val) {
      var item = this.marcas.filter((administracoes) => {
        return administracoes.marcaId == val;
      });
      var toString = JSON.stringify(item);
      var toJson = JSON.parse(toString);
      return toJson[0].tabelaMarcasModelos;
    },
    fnConcat2(val, val2) {
      var modelos = this.fnConcatModelos(val2);
      console.log(modelos);
      var item = modelos.filter((data) => {
        return data.modeloId == val;
      });
      var toString = JSON.stringify(item);
      var toJson = JSON.parse(toString);
      return toJson[0].titulo;
    },
    listaModelos() {
      this.modelos = [];
      if (this.cadastro.marcaId != 0)
      {
          var item = this.marcas.filter((data) => {
        return data.marcaId == this.cadastro.marcaId;
      });
      var toString = JSON.stringify(item);
      var toJson = JSON.parse(toString);
      this.modelos = toJson[0].tabelaMarcasModelos;
      }
      this.modelos.push({modeloId:0, titulo:"Outro"})
    },
    convertToken(token) {
      var base64Url = token.split(".")[1];
      var base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
      var jsonPayload = decodeURIComponent(
        atob(base64)
          .split("")
          .map(function (c) {
            return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
          })
          .join("")
      );

      return JSON.parse(jsonPayload);
    },
    async fnDeletar(val) {
      var token = localStorage.getItem(clientKey);
      var dataToken = this.convertToken(token);
      await this.$http
        .delete(`/etapa_11/${val}/${dataToken.ClienteId}`)
        .then(() => {
          let i = this.content.map((item) => item.etapaId).indexOf(val);
          this.content.splice(i, 1);
          getSuccess();
        })
        .catch(() => {});
    },
  },
};
</script>

<style lang="scss" scoped>
.card-header {
  h4 {
    color: #fff;
    text-align: center;
  }
}
.expand-user {
  width: 100% !important;
}
.tr-expand td .content-tr-expand,
.tr-expand td .tr-expand--close {
  display: block !important;
}
</style>